/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */
import { CURRENT_CLIENT_TEMPLATE_VAR } from '@core';
import { HttpClient } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type {
  PowerConsumptionControllerGetFiltersPathParameters,
  PowerConsumptionControllerGetPowerConsumptionParams,
  PowerConsumptionControllerGetPowerConsumptionPathParameters,
  PowerConsumptionControllerGetPowerConsumptionReportParams,
  PowerConsumptionControllerGetPowerConsumptionReportPathParameters,
} from '../models';

@Injectable({ providedIn: 'root' })
export class PowerconsumptionV2Service {
  private readonly http = inject(HttpClient);
  /**
   * Retrieves available filters for power consumption data.
   * @summary Get list of available filters
   */

  getFilters<TData = void>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
  }: PowerConsumptionControllerGetFiltersPathParameters): Observable<TData> {
    return this.http.get<TData>(`/devices/v2/clients/${clientId}/power-consumption/filters`);
  }
  /**
   * Retrieves a list of devices for a client with power consumption data.
   * @summary Get list of devices with power consumption data
   */

  getPowerConsumption<TData = void>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR }: PowerConsumptionControllerGetPowerConsumptionPathParameters,
    params?: PowerConsumptionControllerGetPowerConsumptionParams,
  ): Observable<TData> {
    return this.http.get<TData>(`/devices/v2/clients/${clientId}/power-consumption`, {
      params: (() => {
        const filteredParams: Record<string, string | number | boolean | Array<string | number | boolean>> = {};
        for (const [key, value] of Object.entries(params ?? {})) {
          if (Array.isArray(value)) {
            const filtered = value.filter(
              item => item != null && (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean'),
            ) as Array<string | number | boolean>;
            if (filtered.length) {
              filteredParams[key] = filtered;
            }
          } else if (value != null && (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')) {
            filteredParams[key] = value;
          }
        }
        return filteredParams;
      })(),
    });
  }
  /**
   * Retrieves all power consumption data for a client and returns it as a JSON file.
   * @summary Generate and download power consumption report
   */

  getPowerConsumptionReport<TData = void>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR }: PowerConsumptionControllerGetPowerConsumptionReportPathParameters,
    params?: PowerConsumptionControllerGetPowerConsumptionReportParams,
  ): Observable<TData> {
    return this.http.get<TData>(`/devices/v2/clients/${clientId}/power-consumption/report`, {
      params: (() => {
        const filteredParams: Record<string, string | number | boolean | Array<string | number | boolean>> = {};
        for (const [key, value] of Object.entries(params ?? {})) {
          if (Array.isArray(value)) {
            const filtered = value.filter(
              item => item != null && (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean'),
            ) as Array<string | number | boolean>;
            if (filtered.length) {
              filteredParams[key] = filtered;
            }
          } else if (value != null && (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')) {
            filteredParams[key] = value;
          }
        }
        return filteredParams;
      })(),
    });
  }
}
